export const columnsDataRevalidations = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "ESTUDIANTE",
    accessor: "nombre",
    computedValue: (rowData) => {
      return `${rowData.nombre || ''} ${rowData.apellido || ''}`.trim() || '-';
    }
  },
  {
    Header: "DOCUMENTO",
    accessor: "documento",
  },
  {
    Header: "MATERIA",
    accessor: "materia",
  },
  {
    Header: "CARRERA",
    accessor: "carrera",
  },
  {
    Header: "INSTITUTO DE ORIGEN",
    accessor: "instituto",
  },
  {
    Header: "FECHA DE ACEPTACIÓN",
    accessor: "fechaAceptacion",
    computedValue: (rowData) => {
      return rowData.fechaAceptacion ? new Date(rowData.fechaAceptacion).toLocaleDateString('es-AR') : '-';
    }
  },
  {
    Header: "FECHA DE CREACIÓN",
    accessor: "fechaCreacion",
    computedValue: (rowData) => {
      return rowData.fechaCreacion ? new Date(rowData.fechaCreacion).toLocaleDateString('es-AR') : '-';
    }
  },
];
